import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { REFI_VEHICLE_LOAN_CONST } from '../../constants/app.constants.js';
import { DebugService } from '../../services/debug.service.js';
import { tags } from '../../constants/tags.js';
import { stratum } from '../../../../constants/stratum.js';
import { ApplicationService } from '../../../services/application.service.js';
import { POLICY_LIMITS_CONST } from '../../services/policy-limits.service.js';

class RefiPaprLimitModal extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiPaprLimitModal');
  }

  static get properties() {
    return {
      apr: { type: Number },
    };
  }

  render() {
    return html`
      <fs-modal-dialog
        id="papr-limit-modal"
        accessible-title="You already have a great rate!"
        dismissible
        size="small"
      >
        <h2 slot="modal-dialog-header">
          Your current rate is better than what we can offer
        </h2>
        <p slot="modal-dialog-body">
          You have an APR of ${this.apr}%, which is lower than what we can
          currently offer. You can always check back later as we may be able to
          offer a lower rate in the future.
        </p>
        <fs-modal-dialog-footer>
          <fs-button variant="primary" @click="${this.handleExitPrequal}"
            >Exit pre-qualification</fs-button
          >
          <fs-button
            variant="secondary"
            ghost
            @click="${this.handleContinuePrequal}"
            >Continue</fs-button
          >
        </fs-modal-dialog-footer>
      </fs-modal-dialog>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  openModal(loan, isManualLoan) {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(
      tags.vehicleAndLoan.paprModalShown(
        loan.apr,
        POLICY_LIMITS_CONST.PAPR_MINIMUM()
      )
    );
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.MIN_PAPR_MODULE_PAPR_MODAL_SHOWN_2
        : TagKey.MIN_PAPR_MODULE_PAPR_MODAL_SHOWN,
      {
        replacements: {
          apr: loan.apr,
          minApr: POLICY_LIMITS_CONST.PAPR_MINIMUM(),
        },
      }
    );
    this.apr = loan.apr;
    this.manualLoanModel = !!isManualLoan;

    const paprModal = this.shadowRoot.querySelector('#papr-limit-modal');
    paprModal.openModalDialog();
  }

  closeModal() {
    const paprModal = this.shadowRoot.getElementById('papr-limit-modal');
    paprModal.closeModalDialog();
  }

  handleContinuePrequal() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(
      tags.vehicleAndLoan.paprContinueClicked
    );
    this.dispatchEvent(
      new CustomEvent('continuePrequal', {
        detail: {
          isManualLoan: this.manualLoanModel,
        },
      })
    );
    this.closeModal();
  }

  handleExitPrequal() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(tags.vehicleAndLoan.paprExitClicked);
    this.dispatchEvent(new CustomEvent('exitPrequal'));
  }
}

customElements.define('refi-papr-limit-modal', RefiPaprLimitModal);
